import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["languageSwitcher", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.date.to-string.js";
import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { concatClassNames as a } from "@sys42/utils";
import { useState as w, useContext as v, Fragment as _ } from "react";
import { featureOverviewFeatures as h, urlCreateAccount as y, urlBookADemo as V, urlTesterRegistration as T, urlKnowledgeBaseTester as H, urlTesterLogin as A } from "../../constants.js";
import { WebsiteContext as N } from "../../context/website.js";
import { addUtmParams as M } from "../../helpers.js";
import { ButtonPrimaryFooter as u } from "../ButtonPrimaryFooter/index.js";
import { SocialLinks as F } from "../SocialLinks/index.js";
import { WebsiteLink as o } from "../WebsiteLink/index.js";
import { NewsletterSignUp as Z } from "./NewsletterSignUp/index.js";
import '../../assets/index30.css';
var x = "data:image/svg+xml,%3csvg%20width='173'%20height='35'%20viewBox='0%200%20173%2035'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M31.4662%200H25.052C22.5796%200%2020.5568%201.96875%2020.5568%204.375V23.1202C20.5568%2027.5962%2016.805%2031.2476%2012.2061%2031.2476C7.60722%2031.2476%203.85548%2027.5962%203.85548%2023.1202V4.375C3.85548%204.03846%204.14939%203.7524%204.49517%203.7524H10.9094C11.2552%203.7524%2011.5491%204.03846%2011.5491%204.375V23.1202C11.5491%2024.9712%2011.9814%2026.7043%2012.7594%2028.2692C12.8977%2028.5385%2013.2089%2028.6562%2013.5028%2028.5889C14.4537%2028.3702%2015.3355%2027.9159%2016.0443%2027.3101C16.2691%2027.125%2016.3209%2026.8221%2016.1999%2026.5529C15.6985%2025.5096%2015.4219%2024.3486%2015.4219%2023.1202V4.375C15.4219%201.96875%2013.3991%200%2010.9267%200H4.49517C2.02283%200%200%201.96875%200%204.375V23.1202C0%2029.6827%205.48065%2035%2012.2061%2035C18.9316%2035%2024.4123%2029.6659%2024.4123%2023.1202V4.375C24.4123%204.03846%2024.7062%203.7524%2025.052%203.7524H31.4662C31.812%203.7524%2032.1059%204.03846%2032.1059%204.375V23.1202C32.1059%2027.2933%2028.8556%2030.7428%2024.6889%2031.1803C24.516%2031.1971%2024.3431%2031.2981%2024.2394%2031.4327C23.5997%2032.3077%2022.8735%2033.0986%2022.0609%2033.8053C21.646%2034.1755%2021.8535%2034.8317%2022.424%2034.899C22.8735%2034.9495%2023.323%2034.9832%2023.7726%2034.9832C30.498%2034.9832%2035.9787%2029.649%2035.9787%2023.1034V4.375C35.9614%201.96875%2033.9559%200%2031.4662%200Z'%20fill='%2315E0AF'/%3e%3cpath%20d='M65.6126%2019.6541C65.6126%2020.933%2065.3878%2022.094%2064.9383%2023.1373C64.4888%2024.1806%2063.8664%2025.0556%2063.0711%2025.7791C62.293%2026.5027%2061.3594%2027.058%2060.2875%2027.445C59.2156%2027.832%2058.0399%2028.0339%2056.7778%2028.0339C55.5157%2028.0339%2054.3573%2027.832%2053.2681%2027.445C52.1962%2027.058%2051.2626%2026.5027%2050.4673%2025.7791C49.672%2025.0556%2049.0496%2024.1806%2048.6001%2023.1373C48.1505%2022.094%2047.9258%2020.933%2047.9258%2019.6541V6.14209H51.8331V19.5027C51.8331%2020.1253%2051.9196%2020.7479%2052.0752%2021.3536C52.2481%2021.9594%2052.5074%2022.5147%2052.8878%2023.0027C53.2681%2023.4906%2053.7695%2023.8777%2054.4092%2024.1806C55.0316%2024.4834%2055.8269%2024.6349%2056.7432%2024.6349C57.6769%2024.6349%2058.4549%2024.4834%2059.0773%2024.1806C59.6997%2023.8777%2060.2184%2023.4906%2060.5987%2023.0027C60.9791%2022.5147%2061.2557%2021.9762%2061.4113%2021.3536C61.5842%2020.7479%2061.6534%2020.1253%2061.6534%2019.5027V6.14209H65.5607V19.6541H65.6126Z'%20fill='white'/%3e%3cpath%20d='M76.6778%2016.8776C76.3494%2016.4569%2075.8998%2016.0867%2075.312%2015.7838C74.7415%2015.4641%2074.1018%2015.3126%2073.4275%2015.3126C72.8224%2015.3126%2072.2864%2015.4304%2071.785%2015.6828C71.2837%2015.9184%2071.0416%2016.3223%2071.0416%2016.8944C71.0416%2017.4497%2071.3182%2017.8535%2071.8542%2018.0891C72.4074%2018.3247%2073.2027%2018.5602%2074.2574%2018.7958C74.8106%2018.9136%2075.3812%2019.0819%2075.9517%2019.2838C76.5222%2019.4857%2077.0409%2019.755%2077.5077%2020.0747C77.9745%2020.4112%2078.3549%2020.8151%2078.6315%2021.303C78.9254%2021.791%2079.0637%2022.3968%2079.0637%2023.1035C79.0637%2023.9953%2078.8909%2024.7357%2078.5451%2025.3583C78.1993%2025.9641%2077.7498%2026.4689%2077.1792%2026.8559C76.6087%2027.2429%2075.9517%2027.5122%2075.191%2027.6804C74.4303%2027.8487%2073.6523%2027.9328%2072.857%2027.9328C71.6986%2027.9328%2070.5748%2027.7309%2069.4856%2027.3102C68.3964%2026.9064%2067.48%2026.3175%2066.7539%2025.5434L69.209%2023.3054C69.6239%2023.8271%2070.1599%2024.2646%2070.8168%2024.6011C71.4738%2024.9376%2072.2173%2025.1059%2073.0126%2025.1059C73.2892%2025.1059%2073.5485%2025.0723%2073.8251%2025.0218C74.1018%2024.9545%2074.3611%2024.8703%2074.6032%2024.7357C74.8452%2024.6011%2075.0354%2024.4328%2075.1737%2024.2141C75.312%2023.9953%2075.3985%2023.7261%2075.3985%2023.4064C75.3985%2022.8006%2075.1218%2022.3631%2074.5513%2022.1107C73.9808%2021.8415%2073.1336%2021.5891%2071.9925%2021.3199C71.4392%2021.2021%2070.886%2021.0506%2070.3673%2020.8487C69.8487%2020.6636%2069.3646%2020.4112%2068.9496%2020.0915C68.5347%2019.7718%2068.2062%2019.3848%2067.9641%2018.9304C67.7221%2018.4761%2067.5838%2017.8872%2067.5838%2017.2141C67.5838%2016.4064%2067.7567%2015.7165%2068.1025%2015.1276C68.4482%2014.5386%2068.8978%2014.0675%2069.451%2013.6973C70.0043%2013.3271%2070.644%2013.041%2071.3355%2012.8727C72.0444%2012.6876%2072.7532%2012.6035%2073.4967%2012.6035C74.5686%2012.6035%2075.6232%2012.7886%2076.6433%2013.142C77.6633%2013.5122%2078.4759%2014.0506%2079.081%2014.8078L76.6778%2016.8776Z'%20fill='white'/%3e%3cpath%20d='M95.541%2020.4449C95.541%2020.6131%2095.541%2020.7646%2095.541%2020.9328C95.541%2021.1011%2095.5237%2021.2526%2095.5064%2021.4208H84.1993C84.2339%2021.9425%2084.3722%2022.4136%2084.6142%2022.8511C84.8563%2023.2886%2085.1675%2023.6588%2085.5651%2023.9617C85.9628%2024.2814%2086.395%2024.517%2086.8964%2024.7021C87.3978%2024.8872%2087.9165%2024.9713%2088.4524%2024.9713C89.386%2024.9713%2090.1641%2024.803%2090.8038%2024.4665C91.4434%2024.13%2091.9621%2023.6756%2092.3771%2023.0867L94.8494%2025.0218C93.3798%2026.9569%2091.2533%2027.916%2088.4697%2027.916C87.3113%2027.916%2086.2567%2027.7477%2085.2712%2027.3944C84.303%2027.041%2083.4559%2026.553%2082.747%2025.8968C82.0382%2025.2574%2081.4849%2024.4665%2081.07%2023.5242C80.6723%2022.5819%2080.4648%2021.5218%2080.4648%2020.3439C80.4648%2019.1828%2080.6723%2018.1227%2081.07%2017.1636C81.4676%2016.2045%2082.0209%2015.3968%2082.7297%2014.7237C83.4386%2014.0506%2084.2685%2013.529%2085.2194%2013.1588C86.1875%2012.7886%2087.2249%2012.6035%2088.3314%2012.6035C89.3688%2012.6035%2090.3197%2012.7718%2091.2014%2013.1083C92.0831%2013.4449%2092.8439%2013.9328%2093.4836%2014.5891C94.1233%2015.2453%2094.6247%2016.053%2094.9877%2017.029C95.3681%2017.9881%2095.541%2019.1324%2095.541%2020.4449ZM91.8238%2018.8127C91.8238%2018.3583%2091.7547%2017.904%2091.6163%2017.4833C91.478%2017.0627%2091.2706%2016.6925%2090.9766%2016.3727C90.6827%2016.053%2090.3197%2015.8006%2089.8701%2015.5987C89.4206%2015.4136%2088.9019%2015.3126%2088.2968%2015.3126C87.173%2015.3126%2086.2394%2015.6324%2085.4614%2016.2886C84.6834%2016.9449%2084.2512%2017.7862%2084.182%2018.8127H91.8238Z'%20fill='white'/%3e%3cpath%20d='M97.7363%2013.0239H101.298V15.4302H101.367C101.782%2014.5888%20102.353%2013.8989%20103.096%2013.3773C103.839%2012.8557%20104.704%2012.5864%20105.707%2012.5864C105.845%2012.5864%20106.001%2012.5864%20106.173%2012.6033C106.346%2012.6201%20106.485%2012.6369%20106.606%2012.6706V15.9855C106.364%2015.9182%20106.139%2015.8845%20105.966%2015.8677C105.793%2015.8508%20105.62%2015.834%20105.447%2015.834C104.6%2015.834%20103.926%2015.9855%20103.407%2016.2883C102.888%2016.5912%20102.491%2016.9446%20102.197%2017.3821C101.903%2017.8028%20101.713%2018.2403%20101.609%2018.6778C101.505%2019.1153%20101.453%2019.4686%20101.453%2019.7379V27.4951H97.7363V13.0239Z'%20fill='white'/%3e%3cpath%20d='M111.722%204.69482V14.8583H111.809C111.999%2014.6227%20112.224%2014.3703%20112.518%2014.1011C112.812%2013.8318%20113.157%2013.5963%20113.555%2013.3775C113.953%2013.1588%20114.42%2012.9737%20114.973%2012.8222C115.509%2012.6708%20116.114%2012.6035%20116.805%2012.6035C117.86%2012.6035%20118.828%2012.8054%20119.71%2013.1924C120.592%2013.5794%20121.37%2014.1179%20122.009%2014.8078C122.649%2015.4977%20123.151%2016.2886%20123.496%2017.2141C123.842%2018.1395%20124.015%2019.1323%20124.015%2020.1924C124.015%2021.2525%20123.842%2022.2621%20123.496%2023.1876C123.151%2024.1299%20122.666%2024.9376%20122.044%2025.6275C121.422%2026.3174%20120.644%2026.8727%20119.745%2027.2934C118.846%2027.6972%20117.826%2027.916%20116.684%2027.916C115.63%2027.916%20114.644%2027.6972%20113.728%2027.2597C112.812%2026.8222%20112.086%2026.166%20111.567%2025.3246H111.498V27.4953H107.971V4.69482H111.722ZM120.229%2020.1924C120.229%2019.6371%20120.142%2019.065%20119.969%2018.5266C119.796%2017.9713%20119.537%2017.4833%20119.174%2017.029C118.828%2016.5915%20118.379%2016.2381%20117.843%2015.952C117.307%2015.6828%20116.667%2015.5482%20115.958%2015.5482C115.284%2015.5482%20114.662%2015.6828%20114.126%2015.9689C113.59%2016.2549%20113.123%2016.6083%20112.743%2017.0626C112.362%2017.5001%20112.068%2018.0049%20111.878%2018.577C111.688%2019.1323%20111.584%2019.7044%20111.584%2020.2597C111.584%2020.815%20111.688%2021.3871%20111.878%2021.9256C112.068%2022.4809%20112.362%2022.9689%20112.743%2023.4232C113.123%2023.8607%20113.59%2024.2141%20114.126%2024.5001C114.662%2024.7693%20115.267%2024.904%20115.958%2024.904C116.684%2024.904%20117.307%2024.7693%20117.843%2024.4833C118.379%2024.1972%20118.828%2023.8439%20119.174%2023.3895C119.52%2022.952%20119.796%2022.4472%20119.969%2021.8751C120.142%2021.3198%20120.229%2020.7645%20120.229%2020.1924Z'%20fill='white'/%3e%3cpath%20d='M126.367%2013.0239H129.929V15.4302H129.998C130.413%2014.5888%20130.983%2013.8989%20131.727%2013.3773C132.47%2012.8557%20133.335%2012.5864%20134.337%2012.5864C134.476%2012.5864%20134.631%2012.5864%20134.804%2012.6033C134.977%2012.6201%20135.115%2012.6369%20135.236%2012.6706V15.9855C134.994%2015.9182%20134.77%2015.8845%20134.597%2015.8677C134.424%2015.8508%20134.251%2015.834%20134.078%2015.834C133.231%2015.834%20132.557%2015.9855%20132.038%2016.2883C131.519%2016.5912%20131.122%2016.9446%20130.828%2017.3821C130.534%2017.8028%20130.344%2018.2403%20130.24%2018.6778C130.136%2019.1153%20130.084%2019.4686%20130.084%2019.7379V27.4951H126.367V13.0239Z'%20fill='white'/%3e%3cpath%20d='M145.557%2025.661H145.47C145.09%2026.3004%20144.502%2026.8389%20143.672%2027.2427C142.842%2027.6466%20141.909%2027.8653%20140.854%2027.8653C140.249%2027.8653%20139.627%2027.798%20138.987%2027.6466C138.347%2027.4951%20137.742%2027.2427%20137.189%2026.8893C136.636%2026.536%20136.186%2026.0817%20135.823%2025.5095C135.46%2024.9374%20135.287%2024.2307%20135.287%2023.3893C135.287%2022.2956%20135.598%2021.4374%20136.238%2020.798C136.86%2020.1586%20137.673%2019.6706%20138.676%2019.3172C139.661%2018.9807%20140.768%2018.7451%20141.978%2018.6442C143.188%2018.5264%20144.364%2018.4759%20145.522%2018.4759V18.1057C145.522%2017.197%20145.194%2016.5408%20144.52%2016.1033C143.845%2015.6658%20143.05%2015.447%20142.116%2015.447C141.338%2015.447%20140.578%2015.6153%20139.851%2015.935C139.125%2016.2547%20138.537%2016.6417%20138.053%2017.1129L136.134%2014.9086C136.981%2014.1514%20137.95%2013.5793%20139.056%2013.1922C140.163%2012.8052%20141.286%2012.6201%20142.41%2012.6201C143.724%2012.6201%20144.813%2012.8052%20145.678%2013.1586C146.542%2013.5288%20147.217%2013.9999%20147.701%2014.572C148.202%2015.161%20148.548%2015.8004%20148.738%2016.524C148.928%2017.2475%20149.032%2017.9711%20149.032%2018.6946V27.4951H145.557V25.661ZM145.488%2020.899H144.658C144.053%2020.899%20143.43%2020.9326%20142.773%2020.9663C142.116%2021.0167%20141.511%2021.1345%20140.941%2021.3028C140.387%2021.4711%20139.921%2021.7235%20139.54%2022.0264C139.16%2022.3461%20138.987%2022.7667%20138.987%2023.3052C138.987%2023.6417%20139.056%2023.9278%20139.212%2024.1634C139.367%2024.399%20139.575%2024.5841%20139.817%2024.7187C140.059%2024.8533%20140.336%2024.9542%20140.647%2025.0216C140.958%2025.0889%20141.269%2025.1057%20141.58%2025.1057C142.86%2025.1057%20143.828%2024.7692%20144.485%2024.1129C145.142%2023.4567%20145.47%2022.548%20145.47%2021.4038V20.899H145.488Z'%20fill='white'/%3e%3cpath%20d='M151.66%208.11084C151.66%207.5219%20151.885%207.01709%20152.334%206.57959C152.784%206.14209%20153.337%205.92334%20154.029%205.92334C154.703%205.92334%20155.291%206.12526%20155.74%206.54594C156.207%206.96661%20156.432%207.47142%20156.432%208.09401C156.432%208.71661%20156.207%209.23824%20155.74%209.64209C155.274%2010.0628%20154.703%2010.2647%20154.029%2010.2647C153.354%2010.2647%20152.784%2010.0459%20152.334%209.60844C151.885%209.20459%20151.66%208.68296%20151.66%208.11084ZM152.179%2013.0243H155.896V27.4955H152.179V13.0243Z'%20fill='white'/%3e%3cpath%20d='M159.182%2013.0242H162.709V15.3463H162.778C163.106%2014.6227%20163.677%2013.9833%20164.489%2013.428C165.302%2012.8727%20166.27%2012.6035%20167.394%2012.6035C168.362%2012.6035%20169.192%2012.7718%20169.884%2013.1083C170.575%2013.4449%20171.146%2013.8824%20171.595%2014.4208C172.045%2014.9593%20172.356%2015.5819%20172.563%2016.2886C172.771%2016.9953%20172.875%2017.7189%20172.875%2018.4593V27.5122H169.157V19.4857C169.157%2019.065%20169.123%2018.6275%20169.071%2018.1564C169.002%2017.7021%20168.881%2017.2814%20168.673%2016.9112C168.466%2016.541%20168.189%2016.2381%20167.826%2015.9857C167.463%2015.7501%20166.979%2015.6155%20166.391%2015.6155C165.786%2015.6155%20165.267%2015.7333%20164.835%2015.9689C164.403%2016.2045%20164.04%2016.4905%20163.763%2016.8607C163.487%2017.2309%20163.279%2017.6348%20163.124%2018.1059C162.985%2018.5771%20162.899%2019.0482%20162.899%2019.5362V27.4953H159.182V13.0242Z'%20fill='white'/%3e%3c/svg%3e",
  L = "_footer_1ifgd_1",
  S = "_footerContent_1ifgd_17",
  U = "_footerContentInner_1ifgd_22",
  B = "_bottomContent_1ifgd_27",
  k = "_logo_1ifgd_30",
  P = "_navColumns_1ifgd_35",
  D = "_newsletter_1ifgd_39",
  I = "_navColumnB_1ifgd_42",
  j = "_navColumnA_1ifgd_46",
  W = "_navColumnA_active_1ifgd_67",
  z = "_navC2a_1ifgd_107",
  E = "_languageAndSocial_1ifgd_140",
  K = "_languageSwitcher_1ifgd_148",
  O = "_social_1ifgd_151",
  R = "_footerContentBottom_1ifgd_155",
  X = "_copyright_1ifgd_164",
  Y = "_bottomLinks_1ifgd_168",
  t = {
    footer: L,
    footerContent: S,
    footerContentInner: U,
    bottomContent: B,
    logo: k,
    navColumns: P,
    newsletter: D,
    navColumnB: I,
    navColumnA: j,
    navColumnA_active: W,
    navC2a: z,
    languageAndSocial: E,
    languageSwitcher: K,
    social: O,
    footerContentBottom: R,
    copyright: X,
    bottomLinks: Y
  },
  q = /* @__PURE__ */new Date();
function C2(b) {
  var f = b.languageSwitcher,
    p = b.className,
    g = _objectWithoutProperties(b, _excluded),
    _w = w(null),
    _w2 = _slicedToArray(_w, 2),
    C = _w2[0],
    d = _w2[1],
    _v = v(N),
    n = _v.formatMessage,
    m = _v.websiteType;
  function c(i) {
    d(i);
  }
  function l(i, s) {
    C === i && (s.preventDefault(), s.target.blur(), d(null));
  }
  return /* @__PURE__ */e("footer", _objectSpread(_objectSpread({
    className: a(p, t.footer)
  }, g), {}, {
    children: /* @__PURE__ */e("div", {
      className: t.footerContent,
      children: /* @__PURE__ */r("div", {
        className: t.footerContentInner,
        children: [/* @__PURE__ */e("img", {
          className: t.logo,
          src: x,
          alt: "Userbrain Logo"
        }), /* @__PURE__ */r("div", {
          className: t.navColumns,
          children: [/* @__PURE__ */r("nav", {
            className: a(t.navColumnA, C === "features" && t.navColumnA_active),
            children: [/* @__PURE__ */e("h2", {
              children: /* @__PURE__ */e("div", {
                role: "button",
                tabIndex: 0,
                onMouseDown: function onMouseDown(i) {
                  return l("features", i);
                },
                onFocus: function onFocus() {
                  return c("features");
                },
                children: n({
                  id: "footer.features"
                })
              })
            }), h.map(function (i, s) {
              return /* @__PURE__ */r(_, {
                children: [/* @__PURE__ */e(o, {
                  to: i.to,
                  websiteType: "website",
                  children: i.title
                }), s < h.length - 1 && /* @__PURE__ */e("br", {})]
              }, s);
            })]
          }), /* @__PURE__ */r("nav", {
            className: a(t.navColumnA, C === "product" && t.navColumnA_active),
            children: [/* @__PURE__ */e("h2", {
              children: /* @__PURE__ */e("div", {
                role: "button",
                tabIndex: 0,
                onMouseDown: function onMouseDown(i) {
                  return l("product", i);
                },
                onFocus: function onFocus() {
                  return c("product");
                },
                children: n({
                  id: "footer.product"
                })
              })
            }), /* @__PURE__ */e(o, {
              to: "/about",
              websiteType: "website",
              children: n({
                id: "footer.about"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/pricing",
              websiteType: "website",
              children: n({
                id: "footer.pricing"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/user-testing-templates",
              websiteType: "website",
              children: n({
                id: "footer.templates"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/careers",
              websiteType: "website",
              children: n({
                id: "footer.careers"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/contact",
              websiteType: "website",
              children: n({
                id: "footer.contact"
              })
            })]
          }), /* @__PURE__ */r("nav", {
            className: a(t.navColumnA, C === "testing" && t.navColumnA_active),
            children: [/* @__PURE__ */e("h2", {
              children: /* @__PURE__ */e("div", {
                role: "button",
                tabIndex: 0,
                onMouseDown: function onMouseDown(i) {
                  return l("testing", i);
                },
                onFocus: function onFocus() {
                  return c("testing");
                },
                children: "Testing"
              })
            }), /* @__PURE__ */e(o, {
              to: "/user-testing/adobexd-prototype",
              websiteType: "website",
              children: "Adobe XD Prototypes"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/user-testing/axure-prototype",
              websiteType: "website",
              children: "Axure Prototypes"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/user-testing/figma-prototype",
              websiteType: "website",
              children: "Figma Prototypes"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/user-testing/framer-prototype",
              websiteType: "website",
              children: "Framer Prototypes"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/user-testing/invision-prototype",
              websiteType: "website",
              children: "InVision Prototypes"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/user-testing/sketch-prototype",
              websiteType: "website",
              children: "Sketch Prototypes"
            })]
          }), /* @__PURE__ */r("nav", {
            className: a(t.navColumnA, C === "compare" && t.navColumnA_active),
            children: [/* @__PURE__ */e("h2", {
              children: /* @__PURE__ */e("div", {
                role: "button",
                tabIndex: 0,
                onMouseDown: function onMouseDown(i) {
                  return l("compare", i);
                },
                onFocus: function onFocus() {
                  return c("compare");
                },
                children: n({
                  id: "footer.compare"
                })
              })
            }), /* @__PURE__ */e(o, {
              to: "/compare/trymata",
              websiteType: "website",
              children: "TryMata vs. Userbrain"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/compare/userlytics",
              websiteType: "website",
              children: "Userlytics vs. Userbrain"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/compare/usertesting",
              websiteType: "website",
              children: "UserTesting vs. Userbrain"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/compare/userzoom",
              websiteType: "website",
              children: "UserZoom vs. Userbrain"
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/compare/userfeel",
              websiteType: "website",
              children: "Userfeel vs. Userbrain"
            })]
          })]
        }), /* @__PURE__ */r("div", {
          className: t.navColumns,
          children: [/* @__PURE__ */e(Z, {
            className: t.newsletter
          }), /* @__PURE__ */r("nav", {
            className: t.navColumnB,
            children: [/* @__PURE__ */e("h2", {
              children: n({
                id: "footer.customers"
              })
            }), /* @__PURE__ */e("div", {
              className: t.navC2a,
              children: /* @__PURE__ */e(u, {
                customTag: "a",
                href: y,
                children: "Start free trial"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e("a", {
              href: M(V, m === "website" ? "website" : m, "footer"),
              children: n({
                id: "footer.bookADemo"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e("a", {
              href: "https://help.userbrain.com",
              children: n({
                id: "footer.customerHelp"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e(o, {
              to: "/contact/",
              websiteType: "website",
              children: n({
                id: "footer.contactUs"
              })
            })]
          }), /* @__PURE__ */r("nav", {
            className: t.navColumnB,
            children: [/* @__PURE__ */e("h2", {
              children: n({
                id: "footer.testers"
              })
            }), /* @__PURE__ */e("div", {
              className: t.navC2a,
              children: /* @__PURE__ */e(u, {
                customTag: "a",
                href: T,
                children: n({
                  id: "footer.getPaidToTest"
                })
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e("a", {
              href: H,
              children: n({
                id: "footer.testerHelp"
              })
            }), /* @__PURE__ */e("br", {}), /* @__PURE__ */e("a", {
              href: A,
              children: n({
                id: "footer.testerLogin"
              })
            })]
          })]
        }), /* @__PURE__ */r("div", {
          className: t.languageAndSocial,
          children: [/* @__PURE__ */e("div", {
            className: t.languageSwitcher,
            children: f
          }), /* @__PURE__ */e(F, {
            className: t.social
          })]
        }), /* @__PURE__ */r("div", {
          className: t.footerContentBottom,
          children: [/* @__PURE__ */r("div", {
            className: t.copyright,
            children: ["© ", q.getFullYear(), " Userbrain"]
          }), /* @__PURE__ */r("div", {
            className: t.bottomLinks,
            children: [/* @__PURE__ */e(o, {
              to: "/imprint",
              websiteType: "website",
              children: n({
                id: "footer.imprint"
              })
            }), /* @__PURE__ */e(o, {
              to: "/privacy",
              websiteType: "website",
              children: n({
                id: "footer.privacyPolicy"
              })
            }), /* @__PURE__ */e(o, {
              to: "/cookie-policy",
              websiteType: "website",
              children: n({
                id: "footer.cookiePolicy"
              })
            }), /* @__PURE__ */e(o, {
              to: "/terms",
              websiteType: "website",
              children: n({
                id: "footer.termsAndConditions"
              })
            })]
          })]
        })]
      })
    })
  }));
}
export { C2 as Footer };